import React, { createContext, ReactElement, ReactNode } from 'react';

import { FeatureConfig } from '@/utils/athena-feature-config';

export const FeatureContext = createContext<Partial<FeatureConfig> | undefined>(undefined);

interface Props {
  athenaValues?: Partial<FeatureConfig>;
  children: ReactNode;
}

export const FeatureProvider = ({ athenaValues, children }: Props): ReactElement => {
  return <FeatureContext.Provider value={athenaValues}>{children}</FeatureContext.Provider>;
};
